import { RouteResponse as Route } from '@busie/api'
import { FlexContainer, Modal, PathfinderMap } from '@busie/ui-kit'
import {
  CloseIcon as Close,
  PrintRoad,
  ReportRoad,
  SaveRoad,
} from '@busie/ui-kit'
import { metersToMiles } from '@busie/utils'
import React from 'react'
import {
  getAllManeuversFromRoute,
  getPositionFromIndex,
  getTextOnlyFromHtmlMarkup,
  secondsToMinutes,
} from '../../helpers/pathfinder'
import { Marker } from '../../models/Marker'
import { Maneuver } from '../Maneuver'
import {
  Clickable,
  Divider,
  ManeuversContainer,
  MetricsLabel,
  MetricsValue,
  ModalContainer,
  Title,
  VerticalDivider,
} from './styled'

interface Props {
  isOpen: boolean
  onClose: () => void
  route: Route
  markers: Marker[]
}

const DetailsModal: React.FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  onClose,
  route,
  markers,
}) => {
  const maneuvers = getAllManeuversFromRoute(route)

  return (
    <Modal isOpen={isOpen}>
      <ModalContainer fullWidth direction="column">
        <FlexContainer
          fullWidth
          direction="row"
          justify="space-between"
          align="center"
        >
          <Title>Your Journey in details</Title>
          <FlexContainer direction="row" columnGap={5} align="center">
            <Clickable>
              <SaveRoad size="24" />
            </Clickable>
            <Clickable>
              <PrintRoad size="24" />
            </Clickable>
            <Clickable>
              <ReportRoad size="24" />
            </Clickable>
            <Clickable onClick={onClose}>
              <Close />
            </Clickable>
          </FlexContainer>
        </FlexContainer>
        <FlexContainer fullWidth py={4}>
          <PathfinderMap markers={markers} />
        </FlexContainer>
        <ManeuversContainer fullWidth direction="column" rowGap={2}>
          {maneuvers.map((man, index) => (
            <Maneuver
              key={man.id}
              position={getPositionFromIndex(index, maneuvers.length)}
              text={getTextOnlyFromHtmlMarkup(man.instruction)}
            />
          ))}
        </ManeuversContainer>
        <Divider />
        <FlexContainer
          direction="row"
          fullWidth
          columnGap={3}
          pt={4}
          align="flex-start"
        >
          <FlexContainer rowGap={1} direction="column">
            <MetricsValue>{metersToMiles(route.totalDistance)} mi</MetricsValue>
            <MetricsLabel>Total Distance</MetricsLabel>
          </FlexContainer>
          <VerticalDivider />
          <FlexContainer rowGap={1} direction="column">
            <MetricsValue>
              {secondsToMinutes(route.estimateTravelTime)} min
            </MetricsValue>
            <MetricsLabel>Travel Time</MetricsLabel>
          </FlexContainer>
          <VerticalDivider />
          <FlexContainer rowGap={1} direction="column">
            <MetricsValue>${route.tollCost}</MetricsValue>
            <MetricsLabel>Toll Cost</MetricsLabel>
          </FlexContainer>
        </FlexContainer>
      </ModalContainer>
    </Modal>
  )
}

export default DetailsModal
